export default "__VITE_ASSET__NHoaPobt__"